module.exports = __webpack_public_path__ + "img/radio.c8b7a829.svg";